<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { cn } from '../utils'

interface Props {
  class?: HTMLAttributes['class']
}

const props = defineProps<Props>()

const classes = computed(() => cn('flex flex-col gap-4 p-4', props.class))
</script>

<template>
  <div :class="classes">
    <slot />
  </div>
</template>
